import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { RadicalEvent } from '../models/event.model';

export interface EventSearchParams {
  query?: string;
  location?: string;
  category?: string;
  date?: string;
}

@Injectable({
  providedIn: 'root'
})
export class EventService {
  private readonly apiUrl = `${environment.apiUrl}/events`;

  constructor(private http: HttpClient) {}

  getEvents(filters?: EventSearchParams): Observable<RadicalEvent[]> {
    let params = new HttpParams();
    if (filters) {
      if (filters.query) params = params.set('query', filters.query);
      if (filters.location) params = params.set('location', filters.location);
      if (filters.category) params = params.set('category', filters.category);
      if (filters.date) params = params.set('date', filters.date);
    }
    return this.http.get<RadicalEvent[]>(this.apiUrl, { params });
  }

  getEventById(id: number): Observable<RadicalEvent> {
    return this.http.get<RadicalEvent>(`${this.apiUrl}/${id}`);
  }

  /** Aceita o nome do link (/events/night-run-marco-zero) ou o id dos links antigos (/events/8). */
  getEventByPath(idOrSlug: string): Observable<RadicalEvent> {
    return /^\d+$/.test(idOrSlug)
      ? this.getEventById(Number(idOrSlug))
      : this.http.get<RadicalEvent>(`${this.apiUrl}/by-slug/${encodeURIComponent(idOrSlug)}`);
  }

  createEvent(event: RadicalEvent): Observable<RadicalEvent> {
    return this.http.post<RadicalEvent>(this.apiUrl, event);
  }

  updateEvent(id: number, event: Partial<RadicalEvent>): Observable<RadicalEvent> {
    return this.http.put<RadicalEvent>(`${this.apiUrl}/${id}`, event);
  }
}
